export default [
  {
    airline: '8L',
    productCode: 'QLNTH',
    youngMin: 17,
    youngMax: 25,
    oldMin: 55,
    oldMax: Infinity
  },
  {
    airline: 'FU',
    productCode: 'FUQL',
    youngMin: 18,
    youngMax: 24,
    oldMin: 55,
    oldMax: Infinity
  }
]
